<template>
    <div class="homepage">
      <slide></slide>
      <you-may-like></you-may-like>
      <most-singer></most-singer>
      <latest></latest>
      <p style="padding-top: 0.3rem"></p>
      <ringbacktone-top></ringbacktone-top>
      <p style="padding-top: 0.3rem"></p>
      <music-top></music-top>


      <div class="ads" v-for="item in advRight.slice(0, 1)">
        <a :href="item.link">
          <img :src="item.image"/>
        </a>
      </div>

      <album-hot></album-hot>
      <div style="clear: both"></div>
      <entertainment class="d-none"></entertainment>

      <div class="ads" v-for="item in advLeft.slice(0,1)">
        <a :href="item.link">
          <img :src="item.image"/>
        </a>
      </div>

      <partner></partner>
    </div>
</template>

<script>
  import Slide from './Slide'
  import YouMayLike from './YouMayLike'
  import MostSinger from './MostSinger'
  import Latest from './Latest'
  import RingbacktoneTop from './RingbacktoneTop'
  import MusicTop from './MusicTop'
  import AlbumHot from './AlbumHot'
  import Entertainment from './Entertainment'
  import Partner from './Partner'
  export default {
    name: 'Home',
    components: {
      RingbacktoneTop,
      'slide': Slide,
      'you-may-like': YouMayLike,
      'most-singer': MostSinger,
      'latest': Latest,
      'bxh-ringbacktone': RingbacktoneTop,
      'music-top': MusicTop,
      'album-hot': AlbumHot,
      'entertainment': Entertainment,
      'partner': Partner
    },
    data () {
      return {
        sliderList: [],
        advLeft: [],
        advRight: []
      }
    },
    methods: {
      getListAdv(){
        this.advLeft = [];
        this.advRight = [];
        axios.post(api.adv)
          .then(response => {
            var res = response.data.result;
            res.forEach(item => {
              if(item.page == "home" && item.position == 2){
                this.advLeft.push(item);
              }

              if(item.page == "home" && item.position == 1){
                this.advRight.push(item);
              }
            });
          })
          .catch(e => {

          });
      }
    },
    watch: {
      "$route.path": {
        handler: "getListAdv",
        immediate: true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .homeleft{
      /*width: 70%;
      float: left;*/
      padding-left: 0 !important;
    }
    .homeleft-latest{
      width: 49%;
      float: left;
      margin-top: 1rem !important;
    }
    .homeleft-bxh{
      width: 49%;
      float: right;
      margin-top: 1rem !important;
    }
    .homeright{
      /*width: 28%;
      float: right;*/
      padding-right: 0 !important;
    }
    h1, h2 {
        font-weight: normal;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }


  .ads {
    padding: 0 0.4rem;
    margin: 1.5rem 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/wap/Home.vue